import './_CardDescription.scss';
import { ICardDescriptionProps } from './types';
import { Tooltip } from 'kui';
import { blockMarkdown } from '../../../../../../helper/markdownHelper';
import * as React from 'react';
import { CARD_CLASS } from '../../constants';
import { DESCRIPTION_TITLE } from '../../wording';
import ReactHtmlParser from 'react-html-parser';
import { msFileThumbnailStorage } from '../../../../../../helper/authorisation/microsoft/storage/msThumbnail';
import { onImgLoad } from '../helpers/onImgLoad';

export const CardDescription = ({
    description,
    isQuickLook,
    onHeightChange,
    onToggleLoadingImg,
}: ICardDescriptionProps) => {
    const className = CARD_CLASS + '__description';
    const classTooltip = className + '-tooltip';

    const [markdown, setMarkdown] = React.useState('');
    const [isTruncated, setTruncated] = React.useState(false);
    const ref = React.useRef(null);

    React.useEffect(() => {
        setMarkdown(blockMarkdown(description));

        if (isQuickLook) return;
        const el = ref.current as HTMLElement;
        if (el && el.offsetHeight < el.scrollHeight) {
            setTruncated(true);
        }

        if (description && msFileThumbnailStorage.is()) {
            msFileThumbnailStorage.getSrcThumbnails(description)
                .then((text) => {
                    setMarkdown(blockMarkdown(text));
                })
                .catch(() => {})
        }
    }, [description]);

    React.useEffect(() => {
        if (!onHeightChange || !markdown || !ref.current) return;
        const cleanup = onImgLoad(ref.current, onHeightChange, onToggleLoadingImg);
        return cleanup;
    }, [markdown]);

    return (
        <Tooltip
            className={classTooltip}
            value={!isQuickLook && isTruncated && markdown}
            direction={'down'}
        >
            <div className={`${className} ${!isQuickLook ? className + '--truncate' : ''}`}>
                {isQuickLook && <div className={className + '-title'}>{DESCRIPTION_TITLE}</div>}
                <div
                    ref={ref}
                    className={className + '-text'}
                >
                    {ReactHtmlParser(markdown)}
                </div>
            </div>
        </Tooltip>
    );
}
